import React from 'react'
import LanguageSwitcher from '../lanswitcher'
import { useTranslation } from "react-i18next";

import '../App.css';
const Footer = () => {
    const { t } = useTranslation();
  return (
    <section class="footer">
    <div class="footer__links">
        
        <div class="footer__link--wrapper">
            <div class="footer__link--items">
                <h2>{t("about")}</h2>
                <a href="/">{t("how itWorks")}</a>
                <a href="/">{t("testimonial")}</a>
                <a href="/">{t("carreer")}</a>
                <a href="/">{t("investment")}</a>
                <a href="/">{t("termsOfService")}</a>
            </div>
            <div class="footer__link--items">
                <h2>{t("contact")} </h2>
                <a href="/">{t("contact")}</a>
                <a href="/">{t("support")}</a>
                <a href="/">{t("Destination")}</a>
                <a href="/">{t("Sponsership")}</a>
               
            </div>
        </div>   

        <div class="footer__link--wrapper">
            
            
            <div class="footer__link--items">
                <h2>{t("socialMedia")}</h2>
                <a href="/">{t("instagram")}</a>
                <a href="/">{t("facebook")}</a>
                <a href="/">{t("youtube")}</a>
                <a href="/">{t("twitter")}</a>
            </div>                
        </div>  

    </div>

    <div class="social__media">
        <div class="social__media-wrap">

            <div class="Footer__logo">
                <a href="/" id="Footer__logo"> 
                <img src="logo.png" alt="" srcset="" width={"100px"}/>
                </a>
            </div>
      
        <p class="web__right">GMB 2025. All rights 
            reserved By <a href="https://github.com/iamyoussefezzat">Yousef M.Ezzat</a></p>
            <div class="social__icons">
                <a href="/" class="social__icons--link"
                target="_blank">
                    <i class="fab fa-facebook"></i>
                </a>
                <a href="/" class="social__icons--link"
                target="_blank">
                    <i class="fab fa-instagram"></i>
                </a>
                <a href="/" class="social__icons--link"
                target="_blank">
                    <i class="fab fa-twitter"></i>
                </a>
                <a href="/" class="social__icons--link"
                target="_blank">
                    <i class="fab fa-linkedin"></i>
                </a>
            </div>
        </div>
           
    </div>
    

</section>
  )
}

export default Footer